import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const submitNewQuestion = (question) =>
  axios
    .post(`${BASE_URL}/questionSubmit/submitQuestion`, question)
    .then(({ data }) => data);

export const getUserSubmittedQuestions = () =>
  axios
    .get(`${BASE_URL}/questionSubmit/getQuestionsSubmittedForUser`)
    .then(({ data }) => data);

export const deleteUserSubmittedQuestion = (questionId, timestamp) =>
  axios
    .post(
      `${BASE_URL}/questionSubmit/deleteSubmitQuestionForUser/${questionId}`,
      { updatedAt: timestamp },
    )
    .then(({ data }) => data);

export const editSubmitQuestion = (question, questionId, timestamp) =>
  axios
    .patch(`${BASE_URL}/questionSubmit/editSubmitQuestion/${questionId}`, {
      ...question,
      updatedAt: timestamp,
    })
    .then(({ data }) => data);
